const allaccpayableagingdetail = { data: [], loading: true };
export const GetAllAccPayableAgingDetail = (state = allaccpayableagingdetail, action) => {
  switch (action.type) {
    case "get_allaccpayableagingdetail":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
